import { useMemo, useState } from 'react';
import { FlexColumn, FormControls } from '@elementary/common-ui/components';
import { Typography } from '@mui/material';
import { Controller, UseFormReturn } from 'react-hook-form';
import { AddTestForm, ColumnResource } from 'shared/types';
import SeveritySelector from '../SeveritySelector';
import TableTestDescriptionField from './shared/TableTestDescriptionField';
import TestMetadataForm from './shared/TestMetadataForm';

type Props = {
  methods: UseFormReturn<AddTestForm, any, undefined>;
  columnsResourcesData: ColumnResource[];
};

const ColumnsUnique = ({ methods, columnsResourcesData }: Props) => {
  const { control, watch } = methods;

  const [expanded, setExpanded] = useState(true);

  const target = useMemo(() => {
    const resources = watch('resources');

    if (resources.length > 1) {
      return null;
    }
    const resource = resources[0];
    return columnsResourcesData.find((col) => col.id === resource);
  }, [columnsResourcesData, watch]);

  return (
    <FormControls.TestAccordion
      summary="Unique"
      expanded={expanded}
      onChange={(_, val) => setExpanded(val)}
    >
      <FlexColumn sx={{ gap: 3, p: 3 }}>
        <FormControls.FieldsWrapper>
          <Typography sx={{ fontWeight: 'bold' }}>
            Test configuration
          </Typography>
          <Controller
            name="severity"
            control={control}
            defaultValue={{
              conditionalError: { operator: '!=', value: 0 },
            }}
            render={({ field }) => (
              <SeveritySelector {...field} allowConditional />
            )}
          />
        </FormControls.FieldsWrapper>

        <FormControls.Divider />

        <TableTestDescriptionField
          defaultValue={
            target
              ? `The ${target.name} column in the ${target.model_name} table should contain only unique values`
              : 'The column should contain only unique values'
          }
          methods={methods}
        />

        <TestMetadataForm methods={methods} />
      </FlexColumn>
    </FormControls.TestAccordion>
  );
};

export default ColumnsUnique;
